
import { Options, Vue } from "vue-class-component";
import axios from 'axios'
import Sidebar from "@/components/Sidebar.vue"; // @ is an alias to /src
// import Transportcategories from "@/components/Mytickets/TransportCategories.vue";
import TransCategSmall from "@/components/Mytickets/TransCategSmall.vue";
// import Advert from "@/components/Mytickets/Advertisement.vue";
import Alltickets from '../components/Mytickets/Bus/BUsedTicket.vue';
import Validtickets from '../components/Mytickets/Bus/BValidTickets.vue';
import TicketBooking from '../components/BookingProcedures/TicketBooking.vue'
import MobileSidebar from '../components/MobileSidebar.vue';
import router from '../router/index'

@Options({
	components: {
		Sidebar,
		// Transportcategories,
		TransCategSmall,
		// Advert,
		Alltickets,
		Validtickets,
    TicketBooking,
    MobileSidebar
	},
	data() {
		return{
      error_in_booking: false,
      error_in_booking_msg: 'Something went wrong',
      newTicket: null
		}
	},
	mounted() {
		let booking_cache_sessions = localStorage.getItem('current_ticket_booking_data');
		if (booking_cache_sessions != null && booking_cache_sessions != undefined) {
			this.bookTicketHere();
		}
	},
	methods: {
		async bookTicketHere() {
			//book now here 
			let __ticketbooking = 'https://bookinga.herokuapp.com/api/v1/payment/bookingTicket/';
      let __transactionsById = 'https://bookinga.herokuapp.com/api/v1/transaction/';
			let localvar: any = localStorage.getItem('current_ticket_booking_data');
      let redirected_url: string = (window.location).toString()
      let required_url: string = redirected_url.split('?')[1];
      var ticketid: string = '';
      var transactionid: string = '';
      ticketid = required_url.split('&')[0];
      transactionid = required_url.split('&')[1];
      		      
      if (ticketid == ''){
        this.error_in_booking = true;
        this.error_in_booking_msg = 'Invalid ticket details! Please contact our team.';
        return;
      } 
      
      if (transactionid == ''){
        this.error_in_booking = true;
        this.error_in_booking_msg = "Invalid payment details! Please contact our team.";
        return;
      }

      let __ticket_id: string = ticketid.split('=')[1];
      let __transaction_id: string = transactionid.split('=')[1];

			var config = {
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem("jwt")
				}
			}

      let transaction_status;
      let transaction_booked_complete;
      await axios.get(`${__transactionsById}${__transaction_id}`, config)
        .then(res => {
          transaction_status = res.data.data[0].status;
          transaction_booked_complete = res.data.data[0].ticketbooked;

          if (transaction_status == 'successful' && transaction_booked_complete == "false") {
            let ticketdata = JSON.parse(localvar)

            // var ticket_book_data = {
            //   "status": transaction_status,
            //   "ticketId": __ticket_id,
            //   "busCompany": ticketdata.busCompany,
            //   "date": ticketdata.date.split('T')[0],
            //   "departure": ticketdata.departure.toLowerCase(),
            //   "destination": ticketdata.destination.toLowerCase(),  
            //   "price": ticketdata.price.toString(),
            //   "time": ticketdata.time,
            //   "yourName": ticketdata.yourName
            // }

            var ticket_book_data = {
              "scheduleId": ticketdata.scheduleId,
              "status": transaction_status,
              "ticketId": __ticket_id,
              "yourName": ticketdata.yourName
            }
            
            axios.post(__ticketbooking, ticket_book_data, config)
              .then(res => {
                localStorage.removeItem('current_ticket_booking_data');
                router.push('/myTickets/bus');
                
                let newTicket = {
                  "buscompany": res.data.data.company,
                  "busplate": res.data.data.Bus,
                  "date": res.data.data.Date,
                  "departure": res.data.data.To,
                  "destination": res.data.data.From,
                  "name": res.data.data.Name,
                  "price": res.data.data.Price,
                  "time": res.data.data.Time
                }
                this.newTicket = newTicket;
              }).catch(err => {
                this.error_in_booking = true;
                this.error_in_booking_msg = "Something went wrong! Try reloading . . .";
              })

          } else {
            this.error_in_booking = true;
            this.error_in_booking_msg = 'Invalid booking details!';
            localStorage.removeItem('current_ticket_booking_data')
          }
        })
        .catch(err => {
          this.error_in_booking = true;
          this.error_in_booking_msg = err.response.data.message;
        })

		},
    understoodcloserror() {
      this.error_in_booking = false;
      this.error_in_booking_msg = 'Something went wrong'
    }
	}
})
export default class Mytickets extends Vue {

}
